export default __webpack_public_path__ + "static/SCS_Verified_EnvProducDeclarationBasedonLCA_1CG-2fbaad27d395b8d1d869c020700f0ea1.png";